angular.module("avant.smartyStreets")
  .service "SmartyStreetsService",
  ["$http", "$q", "$window", "ConfigService", "ApplicationService", ($http, $q, $window, ConfigService, ApplicationService) ->
    disallowedHeaders =
      "Cache-Control": undefined
      "If-Modified-Since": undefined
      "Pragma": undefined
      "X-CSRF-Token": undefined
      "X-Requested-With": undefined

    successCallback = (response) ->
      return response.data.suggestions if response.data.suggestions
      $q.reject("Sorry, but we couldn’t find an address matching “#{response.config.params.prefix}”.")

    errorCallback = ->
      $q.reject(null)

    suggest: (prefix) ->
      return $q.when(null) unless window.avantEnv.SMARTY_STREETS_ENABLED == "1"
      $http.get "/api/smartystreets",
        headers: disallowedHeaders
        params:
          "auth-id": window.avantEnv.SMARTY_STREETS_CLIENT_AUTH_ID
          prefix: prefix
          suggestions: 10

      .then(successCallback, errorCallback)
        
  ]